export default __webpack_public_path__ + "img/loading.e38ed7e6.jpg";